import React from 'react'


const InlineDiffRenderer = ({ oldValue = '', newValue = '' }) => {
    const diff = require('diff')
    
    const formattedOldValue = oldValue.replace(/<br\/>/g, '\n').replace(/&nbsp;/g, ' ')
    const formattedNewValue = newValue
    

    const differences = diff.diffWordsWithSpace(formattedOldValue, formattedNewValue)
    
    let mergedHtml = ''
    differences.forEach(part => {
        const formattedValue = part.value.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;')
        
        if (part.added) {
            mergedHtml += `<ins title="Added">${formattedValue}</ins>`
        } else if (part.removed) {
            mergedHtml += `<del title="Removed">${formattedValue}</del>`
        } else {
            mergedHtml += formattedValue
        }
    })
    
    return (
        <div 
            className="inline-diff-renderer"
            style={{
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
            }}
            dangerouslySetInnerHTML={{ __html: mergedHtml }}
        />
    )
}

export default InlineDiffRenderer

